import { Divider } from "@heroui/react";
import "./_status.scss";
import { useTranslation } from "react-i18next";
import StatusHook from "./statusHook";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";
import Box from "/app/src/components/generic/components/box";

/**
 * Component for displaying performance
 * @returns JSX.Element
 *
 */
export default function Performance() {
  const { t } = useTranslation();
  const {
    apiCallsByMonth,
    workflowsCount,
    snapshotCount,
    reportCount,
    fileCount,
  } = StatusHook();

  const performanceData = [
    {
      title: (
        <div className="flex items-center font-archivo text-neutral-charcoal text-small font-medium mb-0">
          {t("translation:api_calls_month")}
          <IconToolTip
            content={t("translation:api_calls_30")}
            className="ml-1"
          />
        </div>
      ),
      value: apiCallsByMonth,
    },
    {
      title: (
        <div className="flex items-center font-archivo text-neutral-charcoal text-small font-medium mb-0">
          {t("translation:files_this_month")}
          <IconToolTip
            content={t("translation:files_last_30")}
            className="ml-1"
          />
        </div>
      ),
      value: fileCount,
    },
    {
      title: (
        <div className="flex items-center font-archivo text-neutral-charcoal text-small font-medium mb-0">
          {t("translation:workflows")}
          <IconToolTip
            content={t("translation:active_workflows")}
            className="ml-1"
          />
        </div>
      ),
      value: workflowsCount,
    },
    {
      title: t("translation:reports"),
      value: reportCount,
    },
    {
      title: t("translation:snapshots"),
      value: snapshotCount,
    },
  ];

  return (
    <Box>
      <h2 className="text-neutral-charcoal font-archivo text-medium font-medium mb-0">
        {t("translation:performance")}
      </h2>
      <Divider className="my-3" />
      {performanceData.map((info) => (
        <>
          <div
            className="flex justify-between items-center mb-4"
            key={info.title?.toString()}
          >
            <h3 className="font-archivo text-neutral-charcoal text-small font-medium mb-0">
              {info.title}
            </h3>
            <h3 className="font-archivo text-neutral-smoke text-small font-medium mb-0">
              {info.value}
            </h3>
          </div>
          <Divider className="my-3" />
        </>
      ))}
    </Box>
  );
}
